import { render, staticRenderFns } from "./salesFeeRegister.vue?vue&type=template&id=15806192&scoped=true"
import script from "./salesFeeRegister.vue?vue&type=script&lang=js"
export * from "./salesFeeRegister.vue?vue&type=script&lang=js"
import style0 from "./salesFeeRegister.vue?vue&type=style&index=0&id=15806192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15806192",
  null
  
)

export default component.exports